(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19151,65250],{

/***/ 19151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefAnalysisWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/debtreliefanalysis/logo/index.tsx


function DebtReliefAnalysisLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "303",
        height: "35",
        fill: "none",
        viewBox: "0 0 303 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_6)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E17D5B",
                        d: "M18.204 10.381V4.177L19.4 5.375c.24.24.555.356.865.356a1.22 1.22 0 00.865-2.086L17.847.356a1.22 1.22 0 00-1.729 0l-3.289 3.29a1.22 1.22 0 000 1.729 1.22 1.22 0 001.73 0l1.197-1.198v6.204a9.993 9.993 0 00-8.769 9.92c0 5.521 4.475 9.996 9.996 9.996 5.52 0 9.996-4.475 9.996-9.996 0-5.106-3.827-9.312-8.77-9.92h-.005zm2.489 14.29c-.701.666-1.66 1.063-2.886 1.204v1.495h-1.66v-1.495c-2.08-.246-3.388-1.344-3.925-3.29l3.02-.56c.257.888.911 1.326 1.957 1.326.818 0 1.227-.222 1.227-.672a.64.64 0 00-.286-.555c-.187-.134-.526-.245-1.011-.345-1.899-.385-3.102-.882-3.61-1.478a3.091 3.091 0 01-.766-2.062c0-.859.28-1.618.836-2.278.555-.666 1.408-1.081 2.553-1.257v-1.478H17.8v1.443c1.858.205 3.073 1.093 3.64 2.647l-2.7.847c-.274-.73-.84-1.098-1.688-1.098-.713 0-1.07.228-1.07.69 0 .169.06.309.182.426.123.116.456.24.999.362 1.25.274 2.144.52 2.681.73.544.216.994.578 1.35 1.093.362.514.538 1.121.538 1.822 0 .982-.351 1.806-1.046 2.472l.006.011z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5476B6",
                        d: "M8.477 12.999a6.482 6.482 0 00-.485-.047V9.92l1.198 1.197c.24.24.555.357.864.357a1.22 1.22 0 00.865-2.086L7.629 6.1a1.22 1.22 0 00-1.729 0L2.611 9.39a1.22 1.22 0 000 1.729c.48.479 1.25.479 1.73 0L5.538 9.92v3.271c-3.195.86-5.55 3.774-5.55 7.239a7.496 7.496 0 008.67 7.402 11.18 11.18 0 01-2.91-7.53c0-2.898 1.023-5.34 2.717-7.303h.012zM28.358 13.174V9.92l1.197 1.197c.24.24.555.357.865.357a1.22 1.22 0 00.864-2.086L27.995 6.1a1.22 1.22 0 00-1.729 0l-3.289 3.29a1.22 1.22 0 000 1.729c.479.479 1.25.479 1.73 0l1.197-1.198v3.038c-.14.011-.28.023-.42.04a11.17 11.17 0 012.716 7.303c0 2.787-1.104 5.539-2.91 7.53a7.496 7.496 0 003.061-14.658h.007z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E17D5B",
                        d: "M42.18 8.769h5.714c6.175 0 10.153 3.073 10.153 10.02 0 6.945-3.978 10.194-9.896 10.194H42.18V8.769zm5.439 16.533c3.43 0 5.743-1.682 5.743-6.514 0-4.831-2.32-6.338-5.743-6.338h-.865v12.852h.865zM60.594 21.294c0-4.989 3.564-8.067 7.256-8.067 4.382 0 6.555 3.183 6.555 7.384 0 .824-.1 1.642-.187 2.015h-9.207c.409 2.232 1.94 3.255 3.99 3.255 1.163 0 2.208-.357 3.33-1.005l1.507 2.745c-1.577 1.093-3.633 1.736-5.456 1.736-4.388 0-7.782-2.968-7.782-8.063h-.006zm9.914-1.688c0-1.694-.736-2.91-2.559-2.91-1.443 0-2.681.965-2.997 2.91h5.556zM81.608 27.341h-.11l-.38 1.642h-3.564V7.256h4.557v5.31L82 14.932c1.168-1.045 2.617-1.705 4.072-1.705 3.727 0 6.029 3.078 6.029 7.799 0 5.304-3.143 8.33-6.473 8.33-1.373 0-2.793-.695-4.02-2.015zm5.819-6.245c0-2.763-.853-4.142-2.676-4.142-.934 0-1.752.42-2.646 1.379v6.315c.818.724 1.682.976 2.453.976 1.59 0 2.863-1.344 2.863-4.528h.006zM95.133 23.386V17.17H93.03v-3.4l2.354-.175.531-4.084h3.769v4.084h3.686v3.575h-3.686v6.157c0 1.747.794 2.442 1.992 2.442.508 0 1.057-.145 1.46-.292l.719 3.313c-.818.257-1.928.56-3.418.56-3.803 0-5.31-2.4-5.31-5.964h.006zM110.492 8.769h7.279c4.288 0 7.799 1.49 7.799 6.292s-3.517 6.642-7.799 6.642h-2.711v7.274h-4.568V8.769zm6.905 9.312c2.401 0 3.692-1.028 3.692-3.014 0-1.986-1.291-2.664-3.692-2.664h-2.337v5.684h2.337v-.006zm-.462 2.425l3.161-2.927 6.45 11.404h-5.112l-4.499-8.477zM127.919 21.294c0-4.989 3.563-8.067 7.255-8.067 4.382 0 6.555 3.183 6.555 7.384 0 .824-.099 1.642-.187 2.015h-9.207c.409 2.232 1.94 3.255 3.99 3.255 1.163 0 2.209-.357 3.33-1.005l1.508 2.745c-1.578 1.093-3.634 1.736-5.457 1.736-4.387 0-7.782-2.968-7.782-8.063h-.005zm9.914-1.688c0-1.694-.736-2.91-2.559-2.91-1.443 0-2.682.965-2.997 2.91h5.556zM144.872 24.204V7.256h4.557v17.129c0 .976.45 1.291.824 1.291.175 0 .298 0 .561-.064l.543 3.36c-.502.215-1.25.379-2.29.379-3.126 0-4.195-2.04-4.195-5.153v.006zM153.39 8.962c0-1.396 1.11-2.384 2.641-2.384 1.53 0 2.64.988 2.64 2.384s-1.11 2.383-2.64 2.383c-1.531 0-2.641-.999-2.641-2.383zm.357 4.633h4.556v15.388h-4.556V13.595zM161.405 21.294c0-4.989 3.564-8.067 7.256-8.067 4.382 0 6.555 3.183 6.555 7.384 0 .824-.105 1.642-.193 2.015h-9.207c.409 2.232 1.94 3.255 3.99 3.255 1.163 0 2.209-.357 3.33-1.005l1.508 2.745c-1.578 1.093-3.634 1.736-5.457 1.736-4.387 0-7.782-2.968-7.782-8.063zm9.914-1.688c0-1.694-.736-2.91-2.558-2.91-1.443 0-2.682.965-2.992 2.91h5.55zM176.945 13.77l2.302-.175h7.075v3.575h-9.377v-3.4zm2.045-.976c0-3.248 1.507-5.918 5.661-5.918 1.285 0 2.39.286 3.067.55l-.823 3.359a4.386 4.386 0 00-1.595-.333c-1.11 0-1.753.613-1.753 2.208v16.317h-4.557V12.794zM196.645 8.769h5.468l6.35 20.214h-4.837l-2.646-10.236c-.561-2.021-1.099-4.41-1.642-6.52h-.123c-.49 2.133-1.028 4.499-1.589 6.52l-2.652 10.236H190.3l6.351-20.214h-.006zm-2.162 11.848h9.727v3.552h-9.727v-3.552zM210.269 13.595h3.721l.327 1.945h.111c1.297-1.244 2.845-2.32 4.943-2.32 3.347 0 4.773 2.36 4.773 6.205v9.552h-4.557v-8.968c0-2.214-.596-2.91-1.91-2.91-1.145 0-1.847.532-2.851 1.496v10.382h-4.557V13.589v.006zM227.298 24.718c0-3.242 2.583-4.995 8.664-5.638-.093-1.343-.765-2.225-2.436-2.225-1.291 0-2.576.543-4.072 1.39l-1.618-2.991c1.951-1.192 4.154-2.027 6.572-2.027 3.932 0 6.111 2.249 6.111 6.963v8.798h-3.721l-.327-1.577h-.111c-1.297 1.14-2.746 1.946-4.475 1.946-2.805 0-4.587-2.045-4.587-4.639zm8.664-.204v-2.688c-3.242.438-4.299 1.361-4.299 2.53 0 .993.683 1.478 1.764 1.478s1.723-.508 2.535-1.315v-.005zM244.346 24.204V7.256h4.557v17.129c0 .976.455 1.291.823 1.291.176 0 .298 0 .561-.064l.543 3.36c-.502.215-1.25.379-2.29.379-3.125 0-4.194-2.04-4.194-5.153v.006zM252.752 34.69l.812-3.476c.287.07.707.199 1.034.199 1.502 0 2.296-.83 2.694-2.021l.228-.8-5.936-14.991h4.58l2.197 6.619c.444 1.396.812 2.85 1.215 4.358h.123c.344-1.455.683-2.915 1.069-4.358l1.869-6.62h4.364l-5.339 15.552c-1.461 3.856-3.103 5.848-6.719 5.848-.958 0-1.565-.123-2.191-.31zM268.012 27.207l2.051-2.84c1.396 1.058 2.681 1.619 3.966 1.619 1.356 0 1.946-.52 1.946-1.326 0-1.017-1.525-1.473-3.108-2.092-1.887-.73-4.072-1.98-4.072-4.522 0-2.862 2.325-4.814 5.877-4.814 2.36 0 4.113.953 5.421 1.952l-2.038 2.74c-1.093-.795-2.174-1.315-3.243-1.315-1.18 0-1.758.462-1.758 1.227 0 .982 1.443 1.355 3.038 1.94 1.945.718 4.142 1.817 4.142 4.632 0 2.816-2.197 4.96-6.322 4.96-2.027 0-4.346-.882-5.906-2.15l.006-.011zM282.752 8.962c0-1.396 1.11-2.384 2.64-2.384 1.531 0 2.641.988 2.641 2.384s-1.11 2.383-2.641 2.383c-1.53 0-2.64-.999-2.64-2.383zm.356 4.633h4.557v15.388h-4.557V13.595zM290.305 27.207l2.051-2.84c1.396 1.058 2.681 1.619 3.967 1.619 1.355 0 1.945-.52 1.945-1.326 0-1.017-1.525-1.473-3.108-2.092-1.887-.73-4.072-1.98-4.072-4.522 0-2.862 2.325-4.814 5.877-4.814 2.361 0 4.113.953 5.422 1.952l-2.039 2.74c-1.093-.795-2.173-1.315-3.242-1.315-1.181 0-1.759.462-1.759 1.227 0 .982 1.443 1.355 3.038 1.94 1.945.718 4.142 1.817 4.142 4.632 0 2.816-2.197 4.96-6.321 4.96-2.027 0-4.347-.882-5.906-2.15l.005-.011z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H302.533V35H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (DebtReliefAnalysisLogo);

// EXTERNAL MODULE: ./src/styles/variables/debtreliefanalysisVariables.module.scss
var debtreliefanalysisVariables_module = __webpack_require__(32549);
var debtreliefanalysisVariables_module_default = /*#__PURE__*/__webpack_require__.n(debtreliefanalysisVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/debtReliefAnalysisWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function DebtReliefAnalysisWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief Analysis",
                    domain: "DebtReliefAnalysis.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief Analysis",
                    domain: "DebtReliefAnalysis.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "The Best Debt Relief Companies",
                        phoneNumberColor: (debtreliefanalysisVariables_module_default()).mainColor,
                        iconColor: (debtreliefanalysisVariables_module_default()).mainColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 32549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#e17d5b"};

/***/ })

}]);